import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";

const PowerBIDashboard = ({ reportId, groupId, embedUrl, accessToken, filter }) => {

  const [embedConfig, setEmbedConfig] = useState(null);

  useEffect(() => {
    // Wait until all required values are available
    if (!reportId || !embedUrl || !accessToken) return;

    // Build filter if provided
    let filters = [];
    if (filter) {

      // Split into individual filters
      const parts = filter.split(" and ");
      parts.forEach((part) => {
        const match = part.match(/(\w+)\/(\w+)\s+eq\s+(\S+)/);
        if (match) {
          filters.push({
            $schema: "http://powerbi.com/product/schema#basic",
            target: {
              table: match[1], // e.g. "DimCampaign"
              column: match[2], // e.g. "DimCampaign"
            },
            operator: "In",
            values: [isNaN(match[3]) ? match[3] : Number(match[3])],
            filterType: models.FilterType.Basic,
          });
        }
      });
    }

    setEmbedConfig({
      type: "report",
      id: reportId,
      embedUrl: embedUrl,
      accessToken: accessToken,
      tokenType: models.TokenType.Embed,
      filters: filters,
      settings: {
        panes: {
          filters: { expanded: false, visible: false },
          pageNavigation: { visible: false },
        },
        background: models.BackgroundType.Transparent,
      },
    });
  }, [reportId, embedUrl, accessToken, filter]);

  if (!embedConfig) {
    return (
      <div className="d-flex justify-content-center align-items-center"
        style={{ height: "500px" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <PowerBIEmbed
      embedConfig={embedConfig}
      cssClassName="powerbi-report-iframe"
    />
  );
};

export default PowerBIDashboard;
